import { useState } from "react";
import { clientError } from "src/context/errors";
import { requestResetPasswordType } from "src/services/authInterface";
import authService from "src/services/authService";
import { responseReducer } from "src/utils/responseReducer";

const useRequestResetPassword = () => {
  const resReducer = responseReducer<requestResetPasswordType>();
  const [loading, setLoading] = useState(false);

  const requestResetPassword = async (brokerID: string, phoneNo: string) => {
    try {
      setLoading(true);
      const data = await authService.requestResetPassword(brokerID, phoneNo);
      switch (data.__typename) {
        case "RequestResetPassword":
          return resReducer(undefined, data);
        case "Error":
          return resReducer(data);
        default:
          return resReducer(clientError.connectionWentWrong);
      }
    } catch {
      return resReducer(clientError.somethingWentWrong);
    } finally {
      setLoading(false);
    }
  };

  return {
    requestResetPassword,
    loading,
  };
};

export default useRequestResetPassword;
